import React from "react";

// Reusable animated "searching…" indicator — pulsing rings + bouncing dots.
// Keeps the screen alive while finding a driver / partner or awaiting acceptance.
export default function SearchingPulse({ title, subtitle, icon, testId }) {
  return (
    <div className="flex flex-col items-center gap-3 py-4 text-center" data-testid={testId}>
      <div className="relative flex h-24 w-24 items-center justify-center">
        <span className="absolute inline-flex h-16 w-16 animate-ping rounded-full bg-brand/40" />
        <span className="absolute inline-flex h-20 w-20 animate-ping rounded-full bg-brand/20" style={{ animationDelay: "0.6s" }} />
        <span className="absolute h-[70px] w-[70px] animate-spin rounded-full border-[3px] border-brand/15 border-t-brand border-r-sunny" style={{ animationDuration: "0.9s" }} />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-brand text-white shadow-lg shadow-brand/30">{icon}</span>
      </div>
      <div>
        <p className="text-base font-bold text-ink">{title}</p>
        {subtitle && <p className="mt-1 text-sm text-ink-soft">{subtitle}</p>}
      </div>
      <div className="flex gap-1.5">
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-2 w-2 animate-bounce rounded-full bg-sunny" style={{ animationDelay: `${i * 0.15}s` }} />
        ))}
      </div>
    </div>
  );
}
